import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const cancelWillCallRide = async ({
  willCallRideId,
  cancellationReason,
}: {
  willCallRideId: number;
  cancellationReason: string;
}): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CancelWillCallRide($willCallRideId: Float!, $cancellationReason: String!) {
        cancelWillCallRide(willCallRideId: $willCallRideId, cancellationReason: $cancellationReason) {
          id
        }
      }
    `),
    variables: {
      willCallRideId,
      cancellationReason,
    },
  });

  return !!response.data?.cancelWillCallRide;
};
